import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk.automation.summary.header.misconfigured-settings-dialog.title',
		defaultMessage: 'Choose a different user so your automation rules will run as intended',
		description: '',
	},
});
